import AppointmentAttendeeCard from './AppointmentAttendeeCard';

export default AppointmentAttendeeCard;
